import {Component, OnInit} from '@angular/core';
import {AbstractDynamicFormFieldDirective} from './abstract-dynamic-form-field.directive';
import {dateToStr, strToDate} from './Util';
import {FormFieldType} from '../model/FormFieldType';

@Component({
  selector: 'app-dff-date-and-time',
  templateUrl: './dff-date-and-time.component.html',
  styleUrls: ['./dff-date-and-time.component.scss']
})
export class DffDateAndTimeComponent extends AbstractDynamicFormFieldDirective implements OnInit {

  currentDate: Date;
  year = false;
  month = false;
  day = false;
  time = false;
  size = 2;
  monthTouched = false;
  format: string;


  ngOnInit() {
    this.setComponentsOfDate(this.field.type);
  }

  validate(value: string): string[] {
    return [];
  }

  writeValue(value: string) {
    this.currentDate = strToDate(value);
    if (value) {
      this.monthTouched = true;
    }
  }

  setComponentsOfDate(value: FormFieldType) {

    if (FormFieldType.YEAR === value) {
      this.year = true;
    }

    if (FormFieldType.TIME === value) {
      this.time = true;
    }

    if (FormFieldType.YEAR_AND_MONTH === value) {
      this.month = true;
      this.year = true;
      this.format = 'LLLL';
    }

    if (FormFieldType.DATE === value) {
      this.day = true;
      this.month = true;
      this.year = true;
      this.format = 'MMMM';
    }

    if (FormFieldType.FULL_DATE === value) {
      this.time = true;
      this.day = true;
      this.month = true;
      this.year = true;
      this.format = 'MMMM';
    }

  }

  changeTouched() {
    this.touched = true;
    this.monthTouched = true;
  }

  updateValue() {
    this.changeValue(dateToStr(this.currentDate));
  }
}
